<template>
  <div id="app">
    <Overlay v-if="isLoading()"></Overlay>
    <Loading v-if="isLoading()"></Loading>
    <div class="wrapper">

      <Sidebar v-if="this.$root.isLogged"></Sidebar>

      <div class="main-panel ps">
        <Navbar></Navbar>
        <Searchbar></Searchbar>

        <div class="content">
          <div class="row">
            <div class="col-12">

              <Login v-if="!this.$root.isLogged"></Login>

              <Board v-if="isNavigating('boards') && this.$root.boardId != 0" v-bind:board-id="this.$root.boardId" v-bind:board-title="this.$root.boardTitle"></Board>

              <Admin v-if="isNavigating('admin')"></Admin>

            </div>
          </div>
        </div>

      </div>

      <FooterInfo></FooterInfo>

    </div>
  </div>
</template>

<style>
@import 'https://fonts.googleapis.com/css?family=Poppins:200,300,400,600,700,800';
@import 'https://use.fontawesome.com/releases/v5.0.6/css/all.css';
@import 'https://fonts.googleapis.com/icon?family=Material+Icons';
@import 'assets/css/nucleo-icons.css';
@import 'assets/css/black-dashboard.css?v=1.0.0';
</style>

<script>
import Board from './components/Board.vue'
import FooterInfo from './components/FooterInfo.vue'
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar.vue'
import Login from './components/Login.vue'
import Searchbar from "./components/Searchbar";
import Admin from "./components/Admin/Admin";
import Overlay from "./components/Overlay";
import Loading from "./components/Loading";

export default {
  name: 'App',
  components: {
    Board,
    Searchbar,
    FooterInfo,
    Navbar,
    Sidebar,
    Login,
    Admin,
    Overlay,
    Loading
  },
  methods: {
     isNavigating(name){
         return this.$root.isLogged && this.$root.isNavigating(name);
     },
     isLoading(){
          return this.$root.loading;
     }
  },
  data () {
    return {
    }
  }
}
</script>
